<template>
  <vs-popup class="add-new-carrier"
            id="popup"
            :title="'RATIONALISATIONS'"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <span v-if="!is_on_create_mode">
         <div class="mb-3 vx-row">
          <div class="w-full vx-col md:w-1/4 md:mb-0">
              <span class="label">Rationalisation/Factoring (%)</span>
              <vs-input size="large" v-on:input="calculator()" v-model="rationalisation"  name="name" class="w-full" label=""/>
          </div>
         </div>
        <div id="print_rationalisation_table">
          <h5 style="visibility: hidden" class="mb-2 mt-2" id="print_rationalisation_table_header">RATIONALISATIONS</h5>
          <vs-table sort :hoverFlat="true" id="rationalisation_table" noDataText="No raw materials available"  :data="raw_material_items"  stripe class="table-dark-inverted table-auto vs-con-loading__container">

          <template slot="thead">
            <vs-th class="__table-heading-small" width="10%">ITS PROD CODE</vs-th>
            <vs-th class="__table-heading-small" width="10%">PROD NAME</vs-th>
            <vs-th class="__table-heading-small" width="10%"></vs-th>
            <vs-th class="__table-heading-small" width="10%">QUANTITY (KG)</vs-th>
            <vs-th class="__table-heading-small" width="10%">PERCENTAGE (%)</vs-th>
            <vs-th class="__table-heading-small font-bold" width="10%">FACTORED QUANTITY (KG)</vs-th>
            <vs-th class="__table-heading-small font-bold" width="10%">FACTORED PERCENTAGE (%)</vs-th>
            <vs-th class="__table-heading-small" width="10%">RM COST IN USE (£/KG)</vs-th>
            <vs-th class="__table-heading-small" width="10%" >RM COST /KG</vs-th>
          </template>

          <template  slot-scope="{data}">
            <vs-tr  :key="indextr" v-for="(tr, indextr) in data">

              <vs-td class="__table-heading-small" :data="data[indextr].company_product_code">

                        <span v-if="tr.formulation_code" style="cursor: pointer" class="text-primary">
                          {{ data[indextr].formulation_code }}
                        </span>
                        <vx-tooltip v-if="tr.company_product_code" text="View raw material" position="left">
                                <span style="cursor: pointer" class="text-primary" @click="onClickLinkToRm(data[indextr].id)">
                                  {{ data[indextr].category + ' ' +  data[indextr].company_product_code }}
                                </span>
                        </vx-tooltip>
                        <span v-if="tr.code" style="cursor: pointer">
                          {{ data[indextr].code }}
                        </span>
              </vs-td>
              <vs-td class="__table-heading-small">
                <span v-if="tr.company_product_name">{{ data[indextr].company_product_name }}</span>
                <span v-if="tr.name">{{ data[indextr].name }}</span>
              </vs-td>

              <vs-td class="__table-heading-small" :data="data[indextr].quantity">
                 <vs-chip v-if="tr.is_3rd_party_rm" size="small" transparent class="__table-heading-small" color="danger">
                      RMs from 3rd party
                  </vs-chip>
              </vs-td>

              <vs-td class="__table-heading-small" :data="data[indextr].quantity">
                {{ data[indextr].quantity }}
              </vs-td>

              <vs-td class="__table-heading-small" >
                {{ data[indextr].percentage }}
              </vs-td>

              <vs-td class="__table-heading-small font-bold" :data="data[indextr].factored_quantity">
                {{ Number(data[indextr].factored_quantity).toFixed(2) }}
              </vs-td>

              <vs-td class="__table-heading-small font-bold" :data="data[indextr].factored_percentage">
                {{ Number(data[indextr].factored_percentage).toFixed(3) }}
              </vs-td>

              <vs-td class="__table-heading-small">
                {{((data[indextr].factored_quantity * data[indextr].cost) / calTotalQuantity()).toFixed(2)}}
              </vs-td>

              <vs-td class="__table-heading-small ml-auto " :data="data[indextr].cost">
                {{(data[indextr].cost).toFixed(2)}}
              </vs-td>

            </vs-tr>
            <vs-tr>
              <vs-td colspan="3">
                <b>Total</b>
              </vs-td>
              <vs-td>{{ calTotalQuantity() }}</vs-td>
              <vs-td>{{ calTotalPercentage() }}</vs-td>
              <vs-td>{{ calTotalFactoredQuantity() }}</vs-td>
              <vs-td>{{ calTotalFactoredPercentage() }}</vs-td>
              <vs-td colspan="2"></vs-td>
            </vs-tr>
          </template>
        </vs-table>
          </div>
          <div class="vx-row mt-4">
          <div v-if="$canAll(formulationPermissions)" class="vx-col w-full">
            <vs-button @click.stop=" open = false" class="float-right" color="warning" size="" type="border">Close</vs-button>
            <vs-button @click.stop="saveFormulations()" class="float-right mr-4" color="primary" size="" type="filled">Save changes</vs-button>
            <vs-button @click.stop="printRationalisation" class="float-right mr-4" color="primary" size="" type="filled">Print</vs-button>
          </div>
      </div>

      </span>



      <ValidationObserver v-if="is_on_create_mode" ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateFormulation)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Formulation Name</small>
                <vs-input v-model="createFormulationForm.name"   name="name" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <small class="label">Formulation Type</small>
              <ValidationProvider vid="formulation_type" name="formulation_type" rules="required" v-slot="{ errors }">
                <v-select :clearable="false" name="formulation_type" placeholder=""
                          label="name" v-model="createFormulationForm.formulation_type"
                          :options="['liquid', 'powder', 'spray dry powder', 'fruit']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="description" name="description" rules="required" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-textarea class="mb-0" v-model="createFormulationForm.description" height="100px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full">
              <ValidationProvider vid="customer_project_brief_id" name="customer_project_brief_id" rules="" v-slot="{ errors }">
                <small class="label">Project brief</small>
                <v-select  :clearable="false" name="customer_project_brief_id" placeholder="" label="name" v-model="createFormulationForm.customer_project_brief_id" :reduce="option => option.id" :options="project_briefs" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template v-slot:option="option">
                    <span>{{option.name}} - {{option.name}}</span>
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3">
            <div class="vx-col  md:w-full w-full md:mb-0">
              <ValidationProvider vid="batch_weight" name="batch_weight" rules="required" v-slot="{ errors }">
                <small class="label">Batch weight (Kg)</small>
                <vs-input type="number" v-model="createFormulationForm.batch_weight" class="w-full"  name="batch_weight" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>



          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Create</vs-button>
          </div>
        </form>
      </ValidationObserver>

    </vx-card>
  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  const FormulationsRepository = RepositoryFactory.get('formulations');
  const CustomerRepository = RepositoryFactory.get('customer');
  const DropDownRepository = RepositoryFactory.get('drop_down')

  import vSelect from 'vue-select'

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  function initialState() {
    return {
      open: false,
      id: '',
      formulationId: '',
      form: {
        name: ''
      },
      raw_material_items: [],
      rationalisation: 100,
      createFormulationForm: { batch_weight: 100 },
      project_briefs: [],
      is_on_create_mode: false
    }
  }

  export default {
    name: 'FormulationRationalisationDuplicatePopUp',
    data() {
      return initialState()
    },
    props: {
      formulationPermissions: {
        type: Array,
        default: [],
      }
    },
    components: {
      'v-select': vSelect,
    },
    methods: {
      async openPopup(raw_material_items, formulationId) {
        try {
          Object.assign(this.$data, initialState());
          this.open = true;
          this.formulationId = formulationId
          // Object.assign(this.raw_material_items,
          //   raw_material_items.map((x) => { x.factored_quantity = x.quantity; x.factored_percentage = x.percentage; return x; }))
          Object.assign(this.raw_material_items, raw_material_items)
          this.calculator()
        } catch (error) {

        }
      },
      printRationalisation(){
        document.body.innerHTML = document.getElementById('print_rationalisation_table').innerHTML;
        window.print();
        location.reload()
      },
      onChangeInput() {
        let carrier = this.raw_material_items.find((n) => n.category && n.category === 'CAR')
        this.raw_material_items =  this.raw_material_items.map((n) => {
          if(n.category !== 'CAR') {
            n.factored_quantity = (Number(n.quantity) * Number(this.rationalisation)) / 100
            n.factored_percentage = (Number(n.factored_quantity) / this.totalQuantity) * 100
          }
          return n
        })
        let total_factored_quantity = 0
        this.raw_material_items.forEach((n) => {
            if(n.category !== 'CAR') {
              total_factored_quantity =  total_factored_quantity + Number(n.factored_quantity)
            }
        })
        this.raw_material_items =  this.raw_material_items.map((n) => {
          if(n.id === carrier.id) {
            n.factored_quantity = (100 - Number(total_factored_quantity))
            n.factored_percentage = (Number(n.factored_quantity) / this.totalQuantity) * 100
          }
          return n
        })
      },
      calculator() {

        const all_carriers = this.raw_material_items.filter((n) => n.category && n.category === 'CAR')
        const total_volume = this.raw_material_items.reduce((a, b) => a + Number(b.quantity), 0)
        const total_carrier_qty = all_carriers.reduce((a, b) => a + Number(b.quantity), 0)

        this.raw_material_items.map((n) => {
          if(n.category === 'CAR') {
            n.rm_ratio = Number(Number(n.quantity) / total_carrier_qty).toFixed(3)
          }
          return n
        })
        this.raw_material_items.map((n) => {
          if(!n.category || n.category !== 'CAR') {
            n.factored_quantity = (Number(n.quantity) * Number(this.rationalisation)) / 100
            n.factored_percentage = (Number(n.factored_quantity) / this.totalQuantity) * 100
          }
          return n
        })

        const raw_materials = this.raw_material_items.filter((n) => (n.category || n.is_3rd_party_rm) && n.category !== 'CAR')
        const total_raw_material_factored_qty = raw_materials.reduce((a, b) => a + Number(b.factored_quantity), 0)

        this.raw_material_items.map((n) => {
          if(n.category === 'CAR') {
            n.factored_quantity = (total_volume - total_raw_material_factored_qty) * n.rm_ratio
            n.factored_percentage = (Number(n.factored_quantity) / this.totalQuantity) * 100
          }
          return n
        })
      },
      async onClickCreateFormulation() {
        const vue = this;
        await this.$vs.loading()
        try {
          let rm_items = []
          Object.assign(rm_items, this.raw_material_items)
          const dil_coded_formulations = rm_items
            .filter((x) => x.formulation_code &&  /^DIL-|^EXT-|^KEY-/.test(x.formulation_code)).map((m) => ({
              id: m.id, quantity: Number(m.factored_quantity).toFixed(4), manufacture_order: m.manufacture_order
            }))
          const raw_material_items = rm_items
            .filter((x) => !x.is_3rd_party_rm && !(x.formulation_code &&  /^DIL-|^EXT-|^KEY-/.test(x.formulation_code))).map((m) => ({
              id: m.id, quantity: Number(m.factored_quantity).toFixed(4), manufacture_order: m.manufacture_order
            }))
          const carrier_items = rm_items
            .filter((x) => x.is_3rd_party_rm).map((m) => ({
              id: m.id, quantity: Number(m.quantity).toFixed(4), manufacture_order: m.manufacture_order + '', finished_quantity: m.is_liquid ? Number(m.finished_quantity).toFixed(4) : 0
            }))

          let payload = this.createFormulationForm
          payload.raw_material_items = raw_material_items
          payload.formulation_items = dil_coded_formulations
          payload.carrier_items = carrier_items
          payload.batch_weight = this.createFormulationForm.batch_weight + ''
          const { data } = (await FormulationsRepository.createWithItems(payload)).data
          await this.$router.push(`/pages/formulations/${data.id}`).then(() => { location.reload() })
          this.showSuccessMessage('Formulation Created!')
          this.open = false
        }catch (e) {
          this.$vs.loading.close()
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async saveFormulations() {
        this.is_on_create_mode = true
        await this.fetchProjectBrief()
      },
      async fetchProjectBrief() {
        await this.$vs.loading()
        try {
          const {data} = await DropDownRepository.getProjectBriefDropDownList()
          this.project_briefs =  data.data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      calTotalQuantity() {
        let total = 0;
        this.raw_material_items.forEach((m) => {
          total = total + Number(m.quantity)
        })
        return total.toFixed(2)
      },
      calTotalFactoredQuantity() {
        let total = 0;
        this.raw_material_items.forEach((m) => {
          total = total + Number(m.factored_quantity)
        })
        return total.toFixed(2)
      },
      calTotalPercentage() {
        let total = 0;
        this.raw_material_items.forEach((m) => {
          total = total + Number(m.percentage)
        })
        return total.toFixed(3)
      },
      calTotalFactoredPercentage() {
        let total = 0;
        this.raw_material_items.forEach((m) => {
          total = total + Number(m.factored_percentage)
        })
        return total.toFixed(3)
      },
    },
    mixins: [SuccessMessage, ErrorMessages],
    computed: {
      isIncludedDilCodedFormulation() {
        return this.raw_material_items.some((x) => x.formulation_code &&  /^DIL-|^EXT-|^KEY-/.test(x.formulation_code))
      },
      totalFactoredQuantity() {
        return this.raw_material_items.reduce((a, b) => a + Number(b.factored_quantity), 0)
      },
      totalQuantity() {
        return this.raw_material_items.reduce((a, b) => a + Number(b.quantity), 0)
      },

    }
  }
</script>

<style scoped>
  .add-new-carrier >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 80% !important;
  }
  .__table-heading-small{
    font-size: small;
  }

  @media print {
    @page {
      size: A4 portrait;
    }

    #print_rationalisation_table {
      left: 0;
      right: 0;
    }

    #print_rationalisation_table_header {
      visibility: visible !important;
    }
  }

</style>
